var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function mergeStepEventIntoEventRecords(events, stepEvent) {
    var _a, _b;
    return __assign(__assign({}, events), (_a = {}, _a[stepEvent.stepName] = (_b = {},
        _b[stepEvent.event] = { data: stepEvent.data },
        _b), _a));
}
0;
//# sourceMappingURL=mergeStepEventIntoEventRecords.js.map